import axios from 'axios';
import config from '../config/environment';

// Use the validated backend URL from config
const API_BASE_URL = config.backendUrl;

console.log('🌐 API Base URL:', API_BASE_URL);
console.log('🔍 Validating URL is not admin panel...');

// Additional runtime validation
if (API_BASE_URL.includes('admin-asset-ticket') || API_BASE_URL.includes('luxury-admin-panel')) {
  console.error('❌ CRITICAL ERROR: Backend URL is pointing to admin panel!');
  console.error('❌ This will cause login failures!');
  throw new Error('Invalid backend URL configuration. Backend URL must point to the API server, not the admin panel.');
}

console.log('✅ Backend URL validation passed');

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 second timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Add Bearer token from localStorage to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔑 Token attached to request:', config.url);
    } else {
      console.warn('⚠️ No token found for request:', config.url);
    }
    
    return config;
  },
  (error) => {
    console.error('❌ Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle 401 errors (token expired/invalid)
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', response.config.url, response.status);
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.error('🚫 401 Unauthorized - Token expired or invalid');
      console.log('🔄 Clearing auth data and redirecting to login...');
      
      // Clear authentication data
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      
      // Redirect to login
      window.location.href = '/login';
    } else {
      console.error('❌ API Error:', error.response?.status, error.message);
    }
    
    return Promise.reject(error);
  }
);

export default api;